import { render, staticRenderFns } from "./BoardPostReplies.vue?vue&type=template&id=2af9d644"
import script from "./BoardPostReplies.vue?vue&type=script&lang=js"
export * from "./BoardPostReplies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports